module.exports = __webpack_public_path__ + "static/media/Culture.a7d255ec.png";